import '../scss/style.scss';

import '../../node_modules/@splidejs/splide/dist/css/splide-core.min.css';

import navigation from './scripts/navigation';
import header from './scripts/header';
import stats from './scripts/stats';
import featuredRecipes from './scripts/featured-recipes';
import accordions from './scripts/accordions';
import productSlider from './scripts/product-slider';

if(document.readyState !== 'loading') {
	runOnStart();
}
else {
	document.addEventListener('DOMContentLoaded', function () {
			runOnStart()
	});
}

function runOnStart() {
	// Run your code here
	navigation();
	header();
	stats();
	featuredRecipes();
	accordions();
	productSlider();

	// Gravity Forms
	jQuery(document).bind('gform_confirmation_loaded', function(event, formID){
		// console.log('gform_confirmation_loaded', event);
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			'event': 'form_submission',
			'formId': formID,
		});
	});
}